import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import apiCall from "../../API/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TopUp = () => {
  const [username, setUsername] = useState("");
  const [amount, setAmount] = useState("");
  const [deposit, setDeposit] = useState("");
  const [withdrawal, setWithdrawal] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("authToken");
  const [packageData, setPackageData] = useState([]);
  const [selectPackage, setSelectPackage] = useState();
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [existUsername, setExistUsername] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!username || !deposit || !withdrawal) {
      toast.error("Please fill in all fields");
      return;
    }

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };
    //   console.log(username, deposit, withdrawal, config);
      const { data, error } = await apiCall(
        "POST",
        "/placeorder",
        {
          username: username,
          withdrawal : withdrawal,
          deposit: deposit
        },
        config
      );

      if (data) {
        // toast.success(data.message);
        setUsername("");
        setDeposit("");
        setWithdrawal("");
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  var x = 0;

//   useEffect(() => {
//     if (x == 0) {
//       fetchPackage();
//       x++;
//     }
//   }, []);
//   const fetchPackage = async (e) => {
//     try {
//       const { data, error } = await apiCall("GET", "/get_plans?type=binary");
//       setPackageData(data?.data);
//       console.log(data.data, "....");
//     } catch (error) {
//       console.log(error);
//     }
//   }; 

  const isUserExist = async () => {
    setLoading(true);

    if (!username) {
      setExistUsername(". . .");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: username,
      });
      if (data) {
        setExistUsername(data.name);
      } else if (error) {
        setExistUsername("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  useEffect(() => {
    // Clear the timeout when the user is typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after the user stops typing
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000) // 500ms debounce delay
    );

    // Cleanup the timeout when the component is unmounted or when typing continues
    return () => clearTimeout(typingTimeout);
  }, [username]);

  return (
    <React.Fragment>
      <Container className="mt-4">
        <section id="add-funds-section">
          <div className="d-flex justify-content-center">
            <h2>TopUp</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={handleSubmit}>
                    <div id="formFields">
                      <div className="mb-3">
                        <div className="d-flex">
                          <label htmlFor="username">User Name:</label>
                          <label
                            style={{ textAlign: "end" }}
                            htmlFor="username"
                          >
                            {loading && username ? "Loading..." : existUsername}
                          </label>
                        </div>
                        <input
                          type="text"
                          id="username"
                          className="form-control"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Enter your Username"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="amount">Deposit Amount:</label>
                        <input
                          type="number"
                          id="depositAmount"
                          className="form-control"
                          value={deposit}
                          onChange={(e) => setDeposit(e.target.value)}
                          placeholder="Enter Deposit Amount"
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="amount">Withdrawal Amount:</label>
                        <input
                          type="number"
                          id="amount"
                          className="form-control"
                          value={withdrawal}
                          onChange={(e) => setWithdrawal(e.target.value)}
                          placeholder="Enter Withdrawal Amount"
                        />
                      </div>

                      {/* <div className="mb-3">
                        <label htmlFor="choosebank">Select Package Type</label>
                        <select
                          className="selectBox"
                          name=""
                          id=""
                          value={selectPackage}
                          onChange={(e) => setSelectPackage(e.target.value)}
                        >
                          <option value="default">--Select Type--</option>
                          {Array.isArray(packageData) &&
                            packageData?.map((x, i) => {
                              return (
                                <option value={x?.planId}>
                                  {x?.packageName}
                                </option>
                              );
                            })}
                        </select>
                      </div> */}
                      {/* <div className="mb-3">
                        <label htmlFor="amount">Amount:</label>
                        <input
                          type="number"
                          id="amount"
                          className="form-control"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter Amount"
                        />
                      </div> */}
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                      <Button
                        variant="secondary"
                        className="ms-2"
                        onClick={() => {
                          setUsername("");
                          setWithdrawal("");
                          setDeposit("");
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
        {/* <ToastContainer className="toast-container" /> */}
      </Container>
    </React.Fragment>
  );
};

export default TopUp;
